import { Ref, useImperativeHandle } from 'react';
import { useContextMenu } from '../../molecules/ContextMenu/useContextMenu';
import { IDataTableMenuEntry } from '../DataTable.types';
import DataTableContextMenu from './DataTableContextMenu';

export interface IDataTableContextMenuHandle {
    /** Открыть меню в точке события (щелчок правой кнопкой, Shift+F10, клавиша меню) */
    openAt: ReturnType<typeof useContextMenu<IDataTableMenuEntry[]>>['openAt'];
    isOpen: () => boolean;
}

/**
 * Контекстное меню шапки и строки со своим состоянием: открытие и закрытие перерисовывают только меню, а не таблицу
 * со всеми строками. Таблица открывает его через ручку.
 */
const DataTableContextMenuHost = ({ ref }: { ref: Ref<IDataTableContextMenuHandle> }) => {
    const { state, openAt, menuProps } = useContextMenu<IDataTableMenuEntry[]>();
    useImperativeHandle(ref, () => ({ openAt, isOpen: () => state !== null }), [openAt, state]);
    return state && <DataTableContextMenu {...menuProps} entries={state.data} />;
};

export default DataTableContextMenuHost;
